<div layout="row">
  <mat-form-field class="contain-icon">
    <mat-icon class="primary">lock</mat-icon>
    <input
      matInput
      [placeholder]="placeholder"
      [formControl]="formControlPassword"
      type="{{ showPassword ? 'text' : 'password' }}"
      required
    />
    <mat-error *ngIf="formControlPassword?.touched && formControlPassword.hasError('required')">
      {{ errorMessage }}
    </mat-error>
    <mat-icon class="password-icon primary" alt="show or hide password" (click)="showPassword = !showPassword">
      {{ showPassword ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </mat-form-field>
</div>
